import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';

import {
  librarySelector,
  scheduleErrorsSelector,
} from 'features/classCreation';
import { useGetHolidayListQuery } from 'services/holidayService';
import Field from 'components/Field';
import ScheduleSuperBatchesSelect from './ScheduleSuperBatchesSelect';
import ScheduleLibrarySelect from './ScheduleLibrarySelect';
import SectionHeading from 'components/SectionHeading';
import styles from './ScheduleClassesPage.module.scss';
import LibraryAndScheduleSection from './LibraryAndScheduleSection';

export default function ScheduleClassesPage() {
  const library = useSelector(librarySelector);
  const errors = useSelector(scheduleErrorsSelector);
  const { error } = useGetHolidayListQuery();

  useEffect(() => {
    if (error) {
      cogoToast.error('Failed to load holidays.');
    }
  }, [error]);

  return (
    <div className={styles.root}>
      <SectionHeading
        title="SCHEDULE CLASSES"
        subtitle="Fill in the following details to schedule classes."
      />
      <Field
        label="Batch and Library"
        name="batch_and_library"
        clientErrors={errors}
      >
        <div className={styles.batchAndLibraryFieldGroup}>
          <ScheduleSuperBatchesSelect />
          <ScheduleLibrarySelect />
        </div>
      </Field>
      {library && <LibraryAndScheduleSection libraryId={library.value} />}
    </div>
  );
}
